// extracted by mini-css-extract-plugin
export default {"addToCartControl":"YZ-z","giftCard":"ZZ-z","btnContainer":"_Z-z","cartButton":"a0-z","disabled":"b0-z"};